export default __webpack_public_path__ + "static/media/TV_Anhanguera.06be32f4.png";